// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { deleteAdageIframeCollectiveTemplateByOfferTemplateIdFavoritesData, deleteAdageIframeCollectiveTemplateByOfferTemplateIdFavoritesErrors, deleteAdageIframeCollectiveTemplateByOfferTemplateIdFavoritesResponses, getAdageIframeAuthenticateData, getAdageIframeAuthenticateErrors, getAdageIframeAuthenticateResponses, getAdageIframeCollectiveAcademiesData, getAdageIframeCollectiveAcademiesErrors, getAdageIframeCollectiveAcademiesResponses, getAdageIframeCollectiveFavoritesData, getAdageIframeCollectiveFavoritesErrors, getAdageIframeCollectiveFavoritesResponses, getAdageIframeCollectiveInstitutionData, getAdageIframeCollectiveInstitutionErrors, getAdageIframeCollectiveInstitutionResponses, getAdageIframeCollectiveOffersByOfferIdData, getAdageIframeCollectiveOffersByOfferIdErrors, getAdageIframeCollectiveOffersByOfferIdResponses, getAdageIframeCollectiveOffersMyInstitutionData, getAdageIframeCollectiveOffersMyInstitutionErrors, getAdageIframeCollectiveOffersMyInstitutionResponses, getAdageIframeCollectiveOffersTemplateByOfferIdData, getAdageIframeCollectiveOffersTemplateByOfferIdErrors, getAdageIframeCollectiveOffersTemplateByOfferIdResponses, getAdageIframeCollectiveOffersTemplateData, getAdageIframeCollectiveOffersTemplateErrors, getAdageIframeCollectiveOffersTemplateResponses, getAdageIframePlaylistsClassroomData, getAdageIframePlaylistsClassroomErrors, getAdageIframePlaylistsClassroomResponses, getAdageIframePlaylistsLocalOfferersData, getAdageIframePlaylistsLocalOfferersErrors, getAdageIframePlaylistsLocalOfferersResponses, getAdageIframePlaylistsNewOfferersData, getAdageIframePlaylistsNewOfferersErrors, getAdageIframePlaylistsNewOfferersResponses, getAdageIframePlaylistsNewTemplateOffersData, getAdageIframePlaylistsNewTemplateOffersErrors, getAdageIframePlaylistsNewTemplateOffersResponses, getAdageIframeTestingTokenData, getAdageIframeTestingTokenErrors, getAdageIframeTestingTokenResponses, getAdageIframeVenuesByVenueIdData, getAdageIframeVenuesByVenueIdErrors, getAdageIframeVenuesByVenueIdResponses, getAdageIframeVenuesSiretBySiretData, getAdageIframeVenuesSiretBySiretErrors, getAdageIframeVenuesSiretBySiretResponses, postAdageIframeCollectiveBookingsData, postAdageIframeCollectiveBookingsErrors, postAdageIframeCollectiveBookingsResponses, postAdageIframeCollectiveOffersTemplateByOfferIdRequestData, postAdageIframeCollectiveOffersTemplateByOfferIdRequestErrors, postAdageIframeCollectiveOffersTemplateByOfferIdRequestResponses, postAdageIframeCollectiveTemplatesByOfferIdFavoritesData, postAdageIframeCollectiveTemplatesByOfferIdFavoritesErrors, postAdageIframeCollectiveTemplatesByOfferIdFavoritesResponses, postAdageIframeLogsBookingModalButtonData, postAdageIframeLogsBookingModalButtonErrors, postAdageIframeLogsBookingModalButtonResponses, postAdageIframeLogsCatalogViewData, postAdageIframeLogsCatalogViewErrors, postAdageIframeLogsCatalogViewResponses, postAdageIframeLogsConsultOfferData, postAdageIframeLogsConsultOfferErrors, postAdageIframeLogsConsultOfferResponses, postAdageIframeLogsConsultPlaylistElementData, postAdageIframeLogsConsultPlaylistElementErrors, postAdageIframeLogsConsultPlaylistElementResponses, postAdageIframeLogsContactModalButtonData, postAdageIframeLogsContactModalButtonErrors, postAdageIframeLogsContactModalButtonResponses, postAdageIframeLogsContactUrlClickData, postAdageIframeLogsContactUrlClickErrors, postAdageIframeLogsContactUrlClickResponses, postAdageIframeLogsFavOfferData, postAdageIframeLogsFavOfferErrors, postAdageIframeLogsFavOfferResponses, postAdageIframeLogsHasSeenWholePlaylistData, postAdageIframeLogsHasSeenWholePlaylistErrors, postAdageIframeLogsHasSeenWholePlaylistResponses, postAdageIframeLogsHeaderLinkClickData, postAdageIframeLogsHeaderLinkClickErrors, postAdageIframeLogsHeaderLinkClickResponses, postAdageIframeLogsOfferDetailData, postAdageIframeLogsOfferDetailErrors, postAdageIframeLogsOfferDetailResponses, postAdageIframeLogsOfferListViewSwitchData, postAdageIframeLogsOfferListViewSwitchErrors, postAdageIframeLogsOfferListViewSwitchResponses, postAdageIframeLogsOfferTemplateDetailData, postAdageIframeLogsOfferTemplateDetailErrors, postAdageIframeLogsOfferTemplateDetailResponses, postAdageIframeLogsPlaylistData, postAdageIframeLogsPlaylistErrors, postAdageIframeLogsPlaylistResponses, postAdageIframeLogsRequestPopinDismissData, postAdageIframeLogsRequestPopinDismissErrors, postAdageIframeLogsRequestPopinDismissResponses, postAdageIframeLogsSatSurveyData, postAdageIframeLogsSatSurveyErrors, postAdageIframeLogsSatSurveyResponses, postAdageIframeLogsSearchButtonData, postAdageIframeLogsSearchButtonErrors, postAdageIframeLogsSearchButtonResponses, postAdageIframeLogsSearchShowMoreData, postAdageIframeLogsSearchShowMoreErrors, postAdageIframeLogsSearchShowMoreResponses, postAdageIframeLogsTrackingAutocompletionData, postAdageIframeLogsTrackingAutocompletionErrors, postAdageIframeLogsTrackingAutocompletionResponses, postAdageIframeLogsTrackingCtaShareData, postAdageIframeLogsTrackingCtaShareErrors, postAdageIframeLogsTrackingCtaShareResponses, postAdageIframeLogsTrackingFilterData, postAdageIframeLogsTrackingFilterErrors, postAdageIframeLogsTrackingFilterResponses, postAdageIframeLogsTrackingMapData, postAdageIframeLogsTrackingMapErrors, postAdageIframeLogsTrackingMapResponses, postAdageIframeRedactorPreferencesData, postAdageIframeRedactorPreferencesErrors, postAdageIframeRedactorPreferencesResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * authenticate <GET>
 */
export const authenticate = <ThrowOnError extends boolean = true>(options?: Options<getAdageIframeAuthenticateData, ThrowOnError>): RequestResult<getAdageIframeAuthenticateResponses, getAdageIframeAuthenticateErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<getAdageIframeAuthenticateResponses, getAdageIframeAuthenticateErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/adage-iframe/authenticate',
    ...options
});

/**
 * get_academies <GET>
 */
export const getAcademies = <ThrowOnError extends boolean = true>(options?: Options<getAdageIframeCollectiveAcademiesData, ThrowOnError>): RequestResult<getAdageIframeCollectiveAcademiesResponses, getAdageIframeCollectiveAcademiesErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<getAdageIframeCollectiveAcademiesResponses, getAdageIframeCollectiveAcademiesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/adage-iframe/collective/academies',
    ...options
});

/**
 * book_collective_offer <POST>
 */
export const bookCollectiveOffer = <ThrowOnError extends boolean = true>(options: Options<postAdageIframeCollectiveBookingsData, ThrowOnError>): RequestResult<postAdageIframeCollectiveBookingsResponses, postAdageIframeCollectiveBookingsErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postAdageIframeCollectiveBookingsResponses, postAdageIframeCollectiveBookingsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/adage-iframe/collective/bookings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * get_collective_favorites <GET>
 */
export const getCollectiveFavorites = <ThrowOnError extends boolean = true>(options?: Options<getAdageIframeCollectiveFavoritesData, ThrowOnError>): RequestResult<getAdageIframeCollectiveFavoritesResponses, getAdageIframeCollectiveFavoritesErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<getAdageIframeCollectiveFavoritesResponses, getAdageIframeCollectiveFavoritesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/adage-iframe/collective/favorites',
    ...options
});

/**
 * get_educational_institution_with_budget <GET>
 */
export const getEducationalInstitutionWithBudget = <ThrowOnError extends boolean = true>(options?: Options<getAdageIframeCollectiveInstitutionData, ThrowOnError>): RequestResult<getAdageIframeCollectiveInstitutionResponses, getAdageIframeCollectiveInstitutionErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<getAdageIframeCollectiveInstitutionResponses, getAdageIframeCollectiveInstitutionErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/adage-iframe/collective/institution',
    ...options
});

/**
 * get_collective_offer_templates <GET>
 */
export const getCollectiveOfferTemplates = <ThrowOnError extends boolean = true>(options: Options<getAdageIframeCollectiveOffersTemplateData, ThrowOnError>): RequestResult<getAdageIframeCollectiveOffersTemplateResponses, getAdageIframeCollectiveOffersTemplateErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getAdageIframeCollectiveOffersTemplateResponses, getAdageIframeCollectiveOffersTemplateErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/adage-iframe/collective/offers-template/',
    ...options
});

/**
 * get_collective_offer_template <GET>
 */
export const getCollectiveOfferTemplate = <ThrowOnError extends boolean = true>(options: Options<getAdageIframeCollectiveOffersTemplateByOfferIdData, ThrowOnError>): RequestResult<getAdageIframeCollectiveOffersTemplateByOfferIdResponses, getAdageIframeCollectiveOffersTemplateByOfferIdErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getAdageIframeCollectiveOffersTemplateByOfferIdResponses, getAdageIframeCollectiveOffersTemplateByOfferIdErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/adage-iframe/collective/offers-template/{offer_id}',
    ...options
});

/**
 * create_collective_request <POST>
 */
export const createCollectiveRequest = <ThrowOnError extends boolean = true>(options: Options<postAdageIframeCollectiveOffersTemplateByOfferIdRequestData, ThrowOnError>): RequestResult<postAdageIframeCollectiveOffersTemplateByOfferIdRequestResponses, postAdageIframeCollectiveOffersTemplateByOfferIdRequestErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postAdageIframeCollectiveOffersTemplateByOfferIdRequestResponses, postAdageIframeCollectiveOffersTemplateByOfferIdRequestErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/adage-iframe/collective/offers-template/{offer_id}/request',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * get_collective_offers_for_my_institution <GET>
 */
export const getCollectiveOffersForMyInstitution = <ThrowOnError extends boolean = true>(options?: Options<getAdageIframeCollectiveOffersMyInstitutionData, ThrowOnError>): RequestResult<getAdageIframeCollectiveOffersMyInstitutionResponses, getAdageIframeCollectiveOffersMyInstitutionErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<getAdageIframeCollectiveOffersMyInstitutionResponses, getAdageIframeCollectiveOffersMyInstitutionErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/adage-iframe/collective/offers/my_institution',
    ...options
});

/**
 * get_collective_offer <GET>
 */
export const getCollectiveOffer = <ThrowOnError extends boolean = true>(options: Options<getAdageIframeCollectiveOffersByOfferIdData, ThrowOnError>): RequestResult<getAdageIframeCollectiveOffersByOfferIdResponses, getAdageIframeCollectiveOffersByOfferIdErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getAdageIframeCollectiveOffersByOfferIdResponses, getAdageIframeCollectiveOffersByOfferIdErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/adage-iframe/collective/offers/{offer_id}',
    ...options
});

/**
 * delete_favorite_for_collective_offer_template <DELETE>
 */
export const deleteFavoriteForCollectiveOfferTemplate = <ThrowOnError extends boolean = true>(options: Options<deleteAdageIframeCollectiveTemplateByOfferTemplateIdFavoritesData, ThrowOnError>): RequestResult<deleteAdageIframeCollectiveTemplateByOfferTemplateIdFavoritesResponses, deleteAdageIframeCollectiveTemplateByOfferTemplateIdFavoritesErrors, ThrowOnError, 'data'> => (options.client ?? client).delete<deleteAdageIframeCollectiveTemplateByOfferTemplateIdFavoritesResponses, deleteAdageIframeCollectiveTemplateByOfferTemplateIdFavoritesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/adage-iframe/collective/template/{offer_template_id}/favorites',
    ...options
});

/**
 * post_collective_template_favorites <POST>
 */
export const postCollectiveTemplateFavorites = <ThrowOnError extends boolean = true>(options: Options<postAdageIframeCollectiveTemplatesByOfferIdFavoritesData, ThrowOnError>): RequestResult<postAdageIframeCollectiveTemplatesByOfferIdFavoritesResponses, postAdageIframeCollectiveTemplatesByOfferIdFavoritesErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postAdageIframeCollectiveTemplatesByOfferIdFavoritesResponses, postAdageIframeCollectiveTemplatesByOfferIdFavoritesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/adage-iframe/collective/templates/{offer_id}/favorites',
    ...options
});

/**
 * log_booking_modal_button_click <POST>
 */
export const logBookingModalButtonClick = <ThrowOnError extends boolean = true>(options: Options<postAdageIframeLogsBookingModalButtonData, ThrowOnError>): RequestResult<postAdageIframeLogsBookingModalButtonResponses, postAdageIframeLogsBookingModalButtonErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postAdageIframeLogsBookingModalButtonResponses, postAdageIframeLogsBookingModalButtonErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/adage-iframe/logs/booking-modal-button',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * log_catalog_view <POST>
 */
export const logCatalogView = <ThrowOnError extends boolean = true>(options: Options<postAdageIframeLogsCatalogViewData, ThrowOnError>): RequestResult<postAdageIframeLogsCatalogViewResponses, postAdageIframeLogsCatalogViewErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postAdageIframeLogsCatalogViewResponses, postAdageIframeLogsCatalogViewErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/adage-iframe/logs/catalog-view',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * log_consult_offer <POST>
 */
export const logConsultOffer = <ThrowOnError extends boolean = true>(options: Options<postAdageIframeLogsConsultOfferData, ThrowOnError>): RequestResult<postAdageIframeLogsConsultOfferResponses, postAdageIframeLogsConsultOfferErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postAdageIframeLogsConsultOfferResponses, postAdageIframeLogsConsultOfferErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/adage-iframe/logs/consult-offer',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * log_consult_playlist_element <POST>
 */
export const logConsultPlaylistElement = <ThrowOnError extends boolean = true>(options: Options<postAdageIframeLogsConsultPlaylistElementData, ThrowOnError>): RequestResult<postAdageIframeLogsConsultPlaylistElementResponses, postAdageIframeLogsConsultPlaylistElementErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postAdageIframeLogsConsultPlaylistElementResponses, postAdageIframeLogsConsultPlaylistElementErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/adage-iframe/logs/consult-playlist-element',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * log_contact_modal_button_click <POST>
 */
export const logContactModalButtonClick = <ThrowOnError extends boolean = true>(options: Options<postAdageIframeLogsContactModalButtonData, ThrowOnError>): RequestResult<postAdageIframeLogsContactModalButtonResponses, postAdageIframeLogsContactModalButtonErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postAdageIframeLogsContactModalButtonResponses, postAdageIframeLogsContactModalButtonErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/adage-iframe/logs/contact-modal-button',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * log_contact_url_click <POST>
 */
export const logContactUrlClick = <ThrowOnError extends boolean = true>(options: Options<postAdageIframeLogsContactUrlClickData, ThrowOnError>): RequestResult<postAdageIframeLogsContactUrlClickResponses, postAdageIframeLogsContactUrlClickErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postAdageIframeLogsContactUrlClickResponses, postAdageIframeLogsContactUrlClickErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/adage-iframe/logs/contact-url-click',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * log_fav_offer_button_click <POST>
 */
export const logFavOfferButtonClick = <ThrowOnError extends boolean = true>(options: Options<postAdageIframeLogsFavOfferData, ThrowOnError>): RequestResult<postAdageIframeLogsFavOfferResponses, postAdageIframeLogsFavOfferErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postAdageIframeLogsFavOfferResponses, postAdageIframeLogsFavOfferErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/adage-iframe/logs/fav-offer/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * log_has_seen_whole_playlist <POST>
 */
export const logHasSeenWholePlaylist = <ThrowOnError extends boolean = true>(options: Options<postAdageIframeLogsHasSeenWholePlaylistData, ThrowOnError>): RequestResult<postAdageIframeLogsHasSeenWholePlaylistResponses, postAdageIframeLogsHasSeenWholePlaylistErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postAdageIframeLogsHasSeenWholePlaylistResponses, postAdageIframeLogsHasSeenWholePlaylistErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/adage-iframe/logs/has-seen-whole-playlist/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * log_header_link_click <POST>
 */
export const logHeaderLinkClick = <ThrowOnError extends boolean = true>(options: Options<postAdageIframeLogsHeaderLinkClickData, ThrowOnError>): RequestResult<postAdageIframeLogsHeaderLinkClickResponses, postAdageIframeLogsHeaderLinkClickErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postAdageIframeLogsHeaderLinkClickResponses, postAdageIframeLogsHeaderLinkClickErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/adage-iframe/logs/header-link-click/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * log_offer_details_button_click <POST>
 */
export const logOfferDetailsButtonClick = <ThrowOnError extends boolean = true>(options: Options<postAdageIframeLogsOfferDetailData, ThrowOnError>): RequestResult<postAdageIframeLogsOfferDetailResponses, postAdageIframeLogsOfferDetailErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postAdageIframeLogsOfferDetailResponses, postAdageIframeLogsOfferDetailErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/adage-iframe/logs/offer-detail',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * log_offer_list_view_switch <POST>
 */
export const logOfferListViewSwitch = <ThrowOnError extends boolean = true>(options: Options<postAdageIframeLogsOfferListViewSwitchData, ThrowOnError>): RequestResult<postAdageIframeLogsOfferListViewSwitchResponses, postAdageIframeLogsOfferListViewSwitchErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postAdageIframeLogsOfferListViewSwitchResponses, postAdageIframeLogsOfferListViewSwitchErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/adage-iframe/logs/offer-list-view-switch',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * log_offer_template_details_button_click <POST>
 */
export const logOfferTemplateDetailsButtonClick = <ThrowOnError extends boolean = true>(options: Options<postAdageIframeLogsOfferTemplateDetailData, ThrowOnError>): RequestResult<postAdageIframeLogsOfferTemplateDetailResponses, postAdageIframeLogsOfferTemplateDetailErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postAdageIframeLogsOfferTemplateDetailResponses, postAdageIframeLogsOfferTemplateDetailErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/adage-iframe/logs/offer-template-detail',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * log_has_seen_all_playlist <POST>
 */
export const logHasSeenAllPlaylist = <ThrowOnError extends boolean = true>(options: Options<postAdageIframeLogsPlaylistData, ThrowOnError>): RequestResult<postAdageIframeLogsPlaylistResponses, postAdageIframeLogsPlaylistErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postAdageIframeLogsPlaylistResponses, postAdageIframeLogsPlaylistErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/adage-iframe/logs/playlist',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * log_request_form_popin_dismiss <POST>
 */
export const logRequestFormPopinDismiss = <ThrowOnError extends boolean = true>(options: Options<postAdageIframeLogsRequestPopinDismissData, ThrowOnError>): RequestResult<postAdageIframeLogsRequestPopinDismissResponses, postAdageIframeLogsRequestPopinDismissErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postAdageIframeLogsRequestPopinDismissResponses, postAdageIframeLogsRequestPopinDismissErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/adage-iframe/logs/request-popin-dismiss',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * log_open_satisfaction_survey <POST>
 */
export const logOpenSatisfactionSurvey = <ThrowOnError extends boolean = true>(options: Options<postAdageIframeLogsSatSurveyData, ThrowOnError>): RequestResult<postAdageIframeLogsSatSurveyResponses, postAdageIframeLogsSatSurveyErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postAdageIframeLogsSatSurveyResponses, postAdageIframeLogsSatSurveyErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/adage-iframe/logs/sat-survey',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * log_search_button_click <POST>
 */
export const logSearchButtonClick = <ThrowOnError extends boolean = true>(options: Options<postAdageIframeLogsSearchButtonData, ThrowOnError>): RequestResult<postAdageIframeLogsSearchButtonResponses, postAdageIframeLogsSearchButtonErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postAdageIframeLogsSearchButtonResponses, postAdageIframeLogsSearchButtonErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/adage-iframe/logs/search-button',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * log_search_show_more <POST>
 */
export const logSearchShowMore = <ThrowOnError extends boolean = true>(options: Options<postAdageIframeLogsSearchShowMoreData, ThrowOnError>): RequestResult<postAdageIframeLogsSearchShowMoreResponses, postAdageIframeLogsSearchShowMoreErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postAdageIframeLogsSearchShowMoreResponses, postAdageIframeLogsSearchShowMoreErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/adage-iframe/logs/search-show-more',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * log_tracking_autocomplete_suggestion_click <POST>
 */
export const logTrackingAutocompleteSuggestionClick = <ThrowOnError extends boolean = true>(options: Options<postAdageIframeLogsTrackingAutocompletionData, ThrowOnError>): RequestResult<postAdageIframeLogsTrackingAutocompletionResponses, postAdageIframeLogsTrackingAutocompletionErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postAdageIframeLogsTrackingAutocompletionResponses, postAdageIframeLogsTrackingAutocompletionErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/adage-iframe/logs/tracking-autocompletion',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * log_tracking_cta_share <POST>
 */
export const logTrackingCtaShare = <ThrowOnError extends boolean = true>(options: Options<postAdageIframeLogsTrackingCtaShareData, ThrowOnError>): RequestResult<postAdageIframeLogsTrackingCtaShareResponses, postAdageIframeLogsTrackingCtaShareErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postAdageIframeLogsTrackingCtaShareResponses, postAdageIframeLogsTrackingCtaShareErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/adage-iframe/logs/tracking-cta-share',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * log_tracking_filter <POST>
 */
export const logTrackingFilter = <ThrowOnError extends boolean = true>(options: Options<postAdageIframeLogsTrackingFilterData, ThrowOnError>): RequestResult<postAdageIframeLogsTrackingFilterResponses, postAdageIframeLogsTrackingFilterErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postAdageIframeLogsTrackingFilterResponses, postAdageIframeLogsTrackingFilterErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/adage-iframe/logs/tracking-filter',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * log_tracking_map <POST>
 */
export const logTrackingMap = <ThrowOnError extends boolean = true>(options: Options<postAdageIframeLogsTrackingMapData, ThrowOnError>): RequestResult<postAdageIframeLogsTrackingMapResponses, postAdageIframeLogsTrackingMapErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postAdageIframeLogsTrackingMapResponses, postAdageIframeLogsTrackingMapErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/adage-iframe/logs/tracking-map',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * get_classroom_playlist <GET>
 */
export const getClassroomPlaylist = <ThrowOnError extends boolean = true>(options?: Options<getAdageIframePlaylistsClassroomData, ThrowOnError>): RequestResult<getAdageIframePlaylistsClassroomResponses, getAdageIframePlaylistsClassroomErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<getAdageIframePlaylistsClassroomResponses, getAdageIframePlaylistsClassroomErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/adage-iframe/playlists/classroom',
    ...options
});

/**
 * get_local_offerers_playlist <GET>
 */
export const getLocalOfferersPlaylist = <ThrowOnError extends boolean = true>(options?: Options<getAdageIframePlaylistsLocalOfferersData, ThrowOnError>): RequestResult<getAdageIframePlaylistsLocalOfferersResponses, getAdageIframePlaylistsLocalOfferersErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<getAdageIframePlaylistsLocalOfferersResponses, getAdageIframePlaylistsLocalOfferersErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/adage-iframe/playlists/local-offerers',
    ...options
});

/**
 * get_new_offerers_playlist <GET>
 */
export const getNewOfferersPlaylist = <ThrowOnError extends boolean = true>(options?: Options<getAdageIframePlaylistsNewOfferersData, ThrowOnError>): RequestResult<getAdageIframePlaylistsNewOfferersResponses, getAdageIframePlaylistsNewOfferersErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<getAdageIframePlaylistsNewOfferersResponses, getAdageIframePlaylistsNewOfferersErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/adage-iframe/playlists/new_offerers',
    ...options
});

/**
 * new_template_offers_playlist <GET>
 */
export const newTemplateOffersPlaylist = <ThrowOnError extends boolean = true>(options?: Options<getAdageIframePlaylistsNewTemplateOffersData, ThrowOnError>): RequestResult<getAdageIframePlaylistsNewTemplateOffersResponses, getAdageIframePlaylistsNewTemplateOffersErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<getAdageIframePlaylistsNewTemplateOffersResponses, getAdageIframePlaylistsNewTemplateOffersErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/adage-iframe/playlists/new_template_offers',
    ...options
});

/**
 * save_redactor_preferences <POST>
 */
export const saveRedactorPreferences = <ThrowOnError extends boolean = true>(options: Options<postAdageIframeRedactorPreferencesData, ThrowOnError>): RequestResult<postAdageIframeRedactorPreferencesResponses, postAdageIframeRedactorPreferencesErrors, ThrowOnError, 'data'> => (options.client ?? client).post<postAdageIframeRedactorPreferencesResponses, postAdageIframeRedactorPreferencesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/adage-iframe/redactor/preferences',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * create_adage_jwt_fake_token <GET>
 */
export const createAdageJwtFakeToken = <ThrowOnError extends boolean = true>(options?: Options<getAdageIframeTestingTokenData, ThrowOnError>): RequestResult<getAdageIframeTestingTokenResponses, getAdageIframeTestingTokenErrors, ThrowOnError, 'data'> => (options?.client ?? client).get<getAdageIframeTestingTokenResponses, getAdageIframeTestingTokenErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/adage-iframe/testing/token',
    ...options
});

/**
 * get_venue_by_siret <GET>
 */
export const getVenueBySiret = <ThrowOnError extends boolean = true>(options: Options<getAdageIframeVenuesSiretBySiretData, ThrowOnError>): RequestResult<getAdageIframeVenuesSiretBySiretResponses, getAdageIframeVenuesSiretBySiretErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getAdageIframeVenuesSiretBySiretResponses, getAdageIframeVenuesSiretBySiretErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/adage-iframe/venues/siret/{siret}',
    ...options
});

/**
 * get_venue_by_id <GET>
 */
export const getVenueById = <ThrowOnError extends boolean = true>(options: Options<getAdageIframeVenuesByVenueIdData, ThrowOnError>): RequestResult<getAdageIframeVenuesByVenueIdResponses, getAdageIframeVenuesByVenueIdErrors, ThrowOnError, 'data'> => (options.client ?? client).get<getAdageIframeVenuesByVenueIdResponses, getAdageIframeVenuesByVenueIdErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/adage-iframe/venues/{venue_id}',
    ...options
});
